import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { default: OldCxRouteMap } = await import('./index');
    return {
        Component: OldCxRouteMap,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
